import { ExitGuideButton, PreviousStepButton } from '../../components';
import nls from '../../../../nls/pt-BR.json';
import { Map } from 'eemovel-map-library';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  advanceToStep,
  setCanAdvance,
  setCurrentProgressTo,
  setPolygon,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import { useTypedSelector } from '../../../../../../../hooks/useTypedSelector';
import { postStudyStep } from '../../../../redux/studies.controller';
import { AddAlert } from '../../../../../../../component';
import { setIsLoadingMap } from '../../../../../redux/dashboardActions';
import {
  PayloadStep1,
  PayloadStep1Circle,
  PayloadStep1Polygon,
} from '../../../../redux/studies.model';

export const DefineRegion: React.FC = () => {
  const dispatch = useDispatch();
  const { currentStep, polygon, id } = useTypedSelector(studiesSelector);
  useEffect(() => {
    dispatch(setCurrentProgressTo(1));
  }, []);
  useEffect(() => {
    const checkForPolygonOnMap = () => {
      const isPoligonOnMap =
        Map.PoligonOnMap && Map.PoligonOnMap.getMap() !== null;
      const isCircleOnMap =
        (Map.markerCircle && Map.markerCircle.getMap() !== null) || false;
      if (isPoligonOnMap || isCircleOnMap) {
        const polygon = isPoligonOnMap ? Map.PoligonOnMap : Map.markerCircle;
        dispatch([setCanAdvance(true), setCurrentProgressTo(1)]);
        dispatch(setPolygon(polygon));
        window.removeEventListener('mouseup', checkForPolygonOnMap);
      } else {
        dispatch([
          setCanAdvance(false),
          setCurrentProgressTo(1),
          setPolygon(null),
        ]);
      }
    };
    checkForPolygonOnMap();
    window.addEventListener('mouseup', checkForPolygonOnMap);

    return () => window.removeEventListener('mouseup', checkForPolygonOnMap);
  }, [Map.PoligonOnMap, Map.markerCircle, Map.drawingManager]);
  const handleClickSetPolygon = async () => {
    try {
      let payload: PayloadStep1;
      if (polygon instanceof google.maps.Circle) {
        const center = polygon.getCenter() as google.maps.LatLng;
        const coordinates = [[center.lat(), center.lng()]];
        const radius = polygon.getRadius();
        payload = {
          location: {
            coordinates,
            radius,
          },
        } as unknown as PayloadStep1Circle;
      } else {
        const latLng = polygon?.getPath().getArray();
        const coordinates = latLng?.map((latlng, index) => [
          latlng.lat(),
          latlng.lng(),
        ]);
        payload = {
          location: {
            coordinates,
          },
        } as PayloadStep1Polygon;
      }
      dispatch(setIsLoadingMap(true));
      const response = await postStudyStep(1, id, payload);
      dispatch([
        AddAlert('success', 'Polígono adicionado'),
        advanceToStep(currentStep.nextStep),
        setIsLoadingMap(false),
      ]);
    } catch (_) {
      dispatch(setIsLoadingMap(false));
    }
  };
  return (
    <>
      <p className="helper-text">{nls.studyCreationGuide.steps.step1.helper}</p>
      <div className="study-creation-guide__buttons-container">
        <div>
          <ExitGuideButton />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 8,
          }}
        >
          <PreviousStepButton />
          <button
            className="btn normal primary"
            data-cy="StudyCreationGuideNextStep"
            disabled={!currentStep.canAdvance}
            onClick={handleClickSetPolygon}
          >
            {nls.studyCreationGuide.buttons.nextStep}
          </button>
        </div>
      </div>
    </>
  );
};
